import React from 'react';
import get from "lodash/get";
import { connect } from 'react-redux';

const ApiErrorMessageComponent = ({apiErrors}) => {
  if(apiErrors && Object.keys(apiErrors).length > 0) {
    return (
      <div className="error-message error-message__api">{get(apiErrors, 'message', '')}</div>
    )
  } else {
    return <div></div>;
  }
}

const mapStateToProps = ({formLoginReducers}) => {
  return {
    apiErrors: formLoginReducers.apiErrors
  }
}

export default connect(mapStateToProps)(ApiErrorMessageComponent);


// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/get_api_error_message.js